export const SAVE = 'baggageAndPersonalItemsSCTIStep.SAVE';
export const VALUE_CHANGED = 'baggageAndPersonalItemsSCTIStep.VALUE_CHANGED';
export const LOAD = 'baggageAndPersonalItemsSCTIStep.VALUE_LOAD';
export const NEXT = 'baggageAndPersonalItemsSCTIStep.NEXT';
export const RESET = 'baggageAndPersonalItemsSCTIStep.RESET';
//----------------------------------------------------
export const RESET_BAGGAGE_DELAY_STATE = 'baggageAndPersonalItemsSCTIStep.RESET_BAGGAGE_DELAY_STATE';
export const RESET_BAGGAGE_BEEN_RETUNRED_STATE = 'baggageAndPersonalItemsSCTIStep.RESET_BAGGAGE_BEEN_RETUNRED_STATE';

export const REPORT_TO = {
  POLICE: '1',
  HOTEL_MANAGEMENT: '2',
  CRUISE_SHIP: '3',
  AIRLINE: '4',
  TOUR_GUIDE: '5',
  OTHER: '6',
  NOT_REPORT: '20',
};

export const CLAIMING_FOR = {
  PASSPORT_CREDIT_CARD: 'claimForPassportCreditCard',
  THEFT_OF_CASH: 'claimForTheftOfCash',
  LUGGAGE_AND_PERSONAL_EFFECTS: 'claimForLuggageAndPersonalEffect',
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.BaggageAndPersonalItems/constants.js